import { Button } from '@features/ui';
import { InstrumentsTable } from '@features/admin/instruments';

export const InstrumentsPage = () => {
  return (
    <div>
      <div className={'flex gap-x-2 justify-between items-center'}>
        <h1 className={'text-[23px]'}>Instruments</h1>
        <div className={'flex gap-x-2.5 items-center'}>
          <p>Upload New Instrument</p>
          <Button className={'rounded-[2px]'} variant={'outline'}>
            Browse
          </Button>
          <Button
            className={'ml-6 rounded-[2px] border-[#33C481]'}
            variant={'outline'}
          >
            <p>Import</p>
            <img
              alt="exel_logo"
              height={16}
              src="/assets/exel_logo.png"
              width={16}
            />
          </Button>
        </div>
      </div>
      <InstrumentsTable />
    </div>
  );
};
